// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__E8bAM","Logo":"Toolbar_Logo__32zQA","DesktopOnly":"Toolbar_DesktopOnly__2mhiP"};